
import axios, { AxiosRequestConfig, AxiosResponse, Method } from 'axios'
import $config from '@/config'
import cookie from 'js-cookie'
import { Message } from 'element-ui'
import { Service } from './index'
import { TokenType } from '@/model/enums'
import { TSObject } from './types'

const SUCCESS_CODE_LIST = ['0000', 'success']
const CODE_NOPERMISSION_LIST = ['11']
const CODE_SERVER_ERROR = ['9999', '500', '503']

const toLogin = function(): void {
  location.href = $config.loginPath
}

const inWhiteList = function(url: string): boolean {
  return $config.whiteList.some(item => url.indexOf(item) > -1)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkResponseCode = function(res: AxiosResponse): any {
  const {
    data
    // config = {}
  } = res

  // if (config.blob)

  // 无结构, 直接返回
  if (!data) return res

  // 逻辑成功
  if (SUCCESS_CODE_LIST.includes(data.code)) {
    // 和后端约定, 接口的返回值为 Result.Data的类型
    return data

  // 无权访问
  } else if (CODE_NOPERMISSION_LIST.includes(data.code)) {
    Message.warning('您无权访问该服务, 即将返回登录界面')
    setTimeout(() => {
      toLogin()
    }, 1500)
  } else if (data.code === '7000') {
    return data
  // 错误
  } else {
    const { code } = data
    if (CODE_SERVER_ERROR.includes(code)) {
      Message.warning('系统正在开小差~请稍后再试！')
    } else {
      Message.warning(data.message)
    }
    return Object.hasOwnProperty.call(data, 'data') ? data.data : data
  }
}

// axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  // #是否需要鉴权
  const needToken = !inWhiteList(config.url || '')

  // 拼接请求地址
  config.url = `${$config.apiHost.replace(/\/$/, '')}${config.url}`

  if (needToken) {
    const token = cookie.get($config.keySSOToken)

    if (token) {
      config.headers = Object.assign({}, config.headers, {
        'v-token': token,
        'v-token-type': TokenType.Normal
      })
      return config
    } else {
      toLogin()
    }
  } else {
    return config
  }
}, err => Promise.reject(err))

axios.interceptors.response.use(response => checkResponseCode(response), err => {
  if (err.response && err.response.status === 403) {
    /* eslint-disable */
    // console.log('Perhaps there is insufficient authority.')
  }
  return Promise.resolve(err)
})

export const Abort = axios.CancelToken

export default {
  async run<T, V>(url: string, method: Method = 'POST', payload?: T, axiosConfig?: AxiosRequestConfig): Promise<V> {
    const cfg: AxiosRequestConfig = Object.assign({}, {
      method,
      url
    }, axiosConfig || {})

    if (payload) {
      if (['POST', 'PUT'].includes(method)) {
        cfg['data'] = payload
      } else {
        // restfull api
        // support: https://domain/api/apiname/{par1}/{par2}?par3=x&par4=y
        const reg = /({[A-Za-zd_-]+})/g
        const mapping = payload as unknown as TSObject
        url.match(reg)?.forEach((parTemplate: string) => {
          const paramName = parTemplate.replace(/[{}]/g, '')
          const param = mapping[paramName] || ''
          cfg.url = cfg.url?.replace(parTemplate, param)
          delete mapping[paramName]
        })
        cfg['params'] = mapping
      }
    }
    const ret = await axios(cfg)

    return ret as unknown as V
  }
}

export let contractInstance: Service | null = null

export const setContractInstance = (instance: Service): void => {
  contractInstance = instance
}
